import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

/**
 * Rendered inside `AppShell` (see `App.tsx`'s wildcard route) so a signed-in
 * user who follows a stale or mistyped link keeps their sidebar/topbar and
 * lands on the same icon+title+description+action card shape every other
 * empty/blocked state in the app uses (`RequireWorkspace`, `RequireAuth`'s
 * permission-denied state) — a wrong URL reads as "nothing here", not as a
 * different, broken product.
 */
export function NotFoundPage() {
  return (
    <div className="grid min-h-[60vh] place-items-center">
      <Card className="w-full max-w-sm">
        <CardContent className="flex flex-col items-center gap-3 py-14 text-center">
          <span className="grid size-12 place-items-center rounded-full bg-primary-muted text-primary ring-1 ring-primary/20">
            <Compass className="size-6" aria-hidden />
          </span>
          <div>
            <p className="font-medium">Page not found</p>
            <p className="mt-1 text-sm text-muted-foreground">
              That link is stale, mistyped, or was moved. Nothing to see here.
            </p>
          </div>
          <Button asChild>
            <Link to="/">Back to Overview</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
